<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12" lg="2" sm="4" xs="6" class="text-right">
          <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="rememberFilterWithSearch" @click:append="getListHandler" outlined dense single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right search-hint-padding" id="searchbtn"></v-text-field>
          <!-- <v-text-field append-icon="mdi-magnify" single-line v-model="filter.search" label="Search" class="text-xs-right" id="searchbtn" hide-details outlined dense></v-text-field> -->
        </v-col>
        <v-col cols="12" lg="9" sm="4" xs="6">
          <v-menu offset-y :close-on-content-click="true" v-model="closeTypeFilter">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on"  class="pl-7 text-capitalize mr-3" :outlined="filter.type !== null ? true : false" color="primary">
                {{$t('message.tickets.type')}} {{ `(${getSelectedName('type', 'type', 'listOfTypes' )})` }}
                <v-icon>mdi-menu-down</v-icon>
                <v-icon small v-if="filter.type !== null ? true : false" @click="clearFilter('type')">mdi-close</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group v-model="menu.type" mandatory>
                <v-list-item v-for="(item, index) in listOfTypes" :key="item.id"  @click="filter.type = item.id, filter.menutickettype = index, setFilter('type', item.id, index)">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu offset-y :close-on-content-click="false" v-model="closeUserFilter" v-if="selectedTab !== 'tab-1' && selectedTab !== 'tab-2'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :text="true" v-on="on" v-bind="attrs" class="text-capitalize mr-3" :outlined="filter.assignedto !== null ? true : false" color="primary">
                {{$t('message.tickets.assignedTo')}} {{ `(${getSelectedName('assignedto', 'assignedto', 'listOfUsersForFilter' )})` }}
                <v-icon>mdi-menu-down</v-icon>
                <v-icon small v-if="filter.assignedto !== null ? true : false" @click="clearFilter('assignedto')">mdi-close</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-toolbar class="pa-0 ma-0" flat color="transparent">
                <v-text-field  append-icon="mdi-magnify" label="Search" hide-details  single-line outlined dense v-model="searchUser"></v-text-field>
              </v-toolbar>
              <v-list-item-group v-model="menu.menuassignedto" mandatory>
                <v-list-item v-for="(item, index) in listOfUserMenu" :key="item.alternateid" @click="filter.assignedto = item.alternateid, filter.menuassignedto = index, closeUserFilter = false">
                  <v-list-item-title>{{ item.fullname }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu offset-y :close-on-content-click="false" v-model="closePriorityFilter">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on"  class="pl-7 text-capitalize mr-3" :outlined="filter.priority !== null ? true : false" color="primary">
                {{$t('message.tickets.priority')}} {{ `(${getSelectedName('priority', 'priority', 'listOfPrioritiesForFilter')})` }}
                <v-icon>mdi-menu-down</v-icon>
                <v-icon small v-if="filter.priority !== null ? true : false" @click="clearFilter('priority')">mdi-close</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-toolbar class="pa-0 ma-0" flat color="transparent">
                <v-text-field  append-icon="mdi-magnify" label="Search" hide-details  single-line outlined dense v-model="searchPriority"></v-text-field>
              </v-toolbar>
              <v-list-item-group v-model="menu.menupriority" mandatory>
                <v-list-item v-for="(item, index) in listOfPriorities" :key="item.id"  @click="filter.priority = item.id, filter.menupriority = index, setFilter('priority', item.id, index)">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu offset-y :close-on-content-click="false" v-model="closeStatusFilter" v-if="selectedTab === 'tab-4'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" class="pl-5 text-capitalize mr-3"  :outlined="filter.status.length === 0 ? false : true" color="primary">
                {{$t('message.tickets.status')}} {{ filter.status.length  > 0 && listOfStatus.length > 0 ? getSelectedName('status', 'status', 'listOfStatusForFilter') :  ''}}
               <v-icon>mdi-menu-down</v-icon>
                <v-icon small v-if="filter.status.length === 0 ? false : true" @click="clearFilter('status')">mdi-close</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-toolbar class="pa-0 ma-0" flat color="transparent">
                <v-text-field  append-icon="mdi-magnify" :label="$t('message.common.search')" hide-details  single-line outlined dense v-model="searchStatus"></v-text-field>
              </v-toolbar>
              <v-list-item-group v-model="filter.status" multiple>
                <v-list-item v-for="(item, index) in listOfStatus" :key="index" @click="setFilter('status', item.id, item)" :value="item.id">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox @click.prevent="" :input-value="active" color="primary"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title class="subtitle-2"><!-- @click="setFilter('status', item.id, item), filter.status.push(item.id)" -->
                      {{ item.name }}
                    </v-list-item-title>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
           <v-menu offset-y :close-on-content-click="false" v-model="closeCategoryFilter">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" class="pl-5 text-capitalize mr-3" :outlined="filter.category !== null ? true : false" color="primary">
                {{$t('message.settings.category')}} {{ `(${getSelectedName('category', 'category', 'listOfCategoryForFilter')})` }}
                <v-icon>mdi-menu-down</v-icon>
                <v-icon small v-if="filter.category !== null ? true : false" @click="clearFilter('category')">mdi-close</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-toolbar class="pa-0 ma-0" flat color="transparent">
                <v-text-field  append-icon="mdi-magnify" label="Search" hide-details  single-line outlined dense v-model="searchType"></v-text-field>
              </v-toolbar>
              <v-list-item-group v-model="filter.menucategory" mandatory>
                <v-list-item v-for="(item, index) in listOfCategory" :key="index" @click="filter.category = item.id, filter.menucategory = index, setFilter('category', item.id)">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-col>
        <!-- <v-col cols="12" lg="1" sm="4" xs="6" class="px-0">
          <v-switch v-model="filter.unread" :label="$t('message.tickets.unread')" hide-details class="mt-0"></v-switch>
        </v-col> -->
      </v-row>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table v-model="selected" :headers="headers" :items="listOfTickets" item-key="id" show-select class="elevation-1 checkboxPadding" dense
        :options.sync="pagination" :loading="loading" :must-sort="true" :server-items-length="total ? total : undefined" :footer-props="paginationList">
        <template v-slot:[`header.totalcommentscount`]="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{header.text}}</span>
            </template>
            <span>{{ $t('message.common.comments') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:body="{ items }" v-if="listOfTickets.length > 0">
        <tbody>
          <tr v-for="(ticket, index) in items" :key="index" >
            <td width="1%">
              <v-checkbox v-model="ticket.isSelected" @change="addToSelected($event, ticket)" hide-details color="primary"></v-checkbox>
            </td>
            <td width="7%">
              <a @click="$router.push(`/tickets/actions/${ticket.id}`)" class="underline">{{ ticket.number }} ({{ticket.totalmailcount}})</a>
              <v-icon v-if="!ticket.lastmailfromcustomer" small> mdi-reply</v-icon>
              <v-icon v-if="ticket.is_task" small>mdi-clipboard-check</v-icon>
              <v-icon v-if="ticket.attachmentscount > 0" small>mdi-attachment mdi-rotate-315</v-icon>
            </td>
            <td width="7%" @click="ticket.showStatus = true">
              <template v-if="ticket.showStatus">
                <v-autocomplete v-model="ticket.status" autocomplete="off" :items="listOfTicketStatus" item-text="name" item-value="id" dense hide-details full-width class="select-font"
                  @blur="updateTickets(ticket.id, index, 'status')"></v-autocomplete>
              </template>
              <template v-else>
                <v-chip class="ma-2" :color="ticket.statuscolor" dark small :text-color="$formatter.foreGroundColor(ticket.statuscolor)">{{ ticket.statusname }}</v-chip>
              </template>
            </td>
            <td width="3%">
              <a @click="getTicketComments(ticket.id)">{{ticket.totalcommentscount}}</a>
            </td>
            <td width="10%">{{ ticket.mailfrom.length > 0 ? ticket.mailfrom[0].Address : '' }}</td>
            <td @click="ticket.showCustomer = true" style="width:10%">
              <template v-if="ticket.showCustomer">
                <v-autocomplete v-model="ticket.customerid" :items="listOfCustomers" item-text="name" item-value="id" dense hide-details full-width class="select-font"
                  @blur="updateTickets(ticket.id, index, 'customer')"></v-autocomplete>
              </template>
              <template v-else>
                {{ ticket.customername }}<!--  {{ticket.account_type ? `(${$t(ticket.account_type)})` : ''}} -->
              </template>
            </td>
            <td class="v-toolbar__title overflow-td" width="9%" :class="ticketIsUnread(ticket) ? 'font-weight-black': ''">
              <a @click="$router.push(`/tickets/actions/${ticket.id}`)" class="underline">{{ ticket.subject }}</a>
            </td>
            <td  width="10%"  @click="ticket.showAssignedTo = true">
              <template v-if="ticket.showAssignedTo">
                <v-autocomplete v-model="ticket.assignedto" autocomplete="off" :items="listOfUserAndGroups" item-text="fullname" item-value="alternateid" dense hide-details full-width class="select-font"
                  @blur="updateTickets(ticket.id, index, 'assignedto')"></v-autocomplete>
              </template>
              <template v-else>
                <span>{{ticket.assignedtoname}}</span>
                <span>{{ticket.assignedto_group_name}}</span>
              </template>
            </td>
            <td width="9%" @click="ticket.showPriority = true">
              <template v-if="ticket.showPriority">
                <v-autocomplete v-model="ticket.priority" autocomplete="off" :items="listOfTicketPriorities" item-text="name" item-value="id" dense hide-details full-width class="select-font"
                  @blur="updateTickets(ticket.id, index, 'priority')"></v-autocomplete>
              </template>
              <template v-else>
                <v-chip class="ma-2" :color="ticket.prioritycolor" dark small :text-color="$formatter.foreGroundColor(ticket.prioritycolor)">{{ ticket.priorityname }}</v-chip>
              </template>
            </td>
            <td width="10%" @click="ticket.showCategory = true">
              <template v-if="ticket.showCategory">
                <v-autocomplete v-model="ticket.category_id" autocomplete="off" :items="listOfTicketCategories" item-text="name" item-value="id" dense hide-details full-width class="select-font"
                  @blur="updateTickets(ticket.id, index, 'category')"></v-autocomplete>
              </template>
              <template v-else>
                {{ ticket.categoryname }}
              </template>
            </td>
            <td width="7%">{{ $formatter.formatDate(ticket.lastmodifiedon,'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm') }}</td>
            <td style="width:7%">{{ $formatter.formatDate(ticket.lastrepliedon,'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm') }}</td>
            <td style="width:7%">{{ ticket.modifiedbyname }}</td>
            <td width="8%">{{ ticket.mailboxname }}</td>
          </tr>
        </tbody>
      </template>
      <template v-slot:no-data>
        {{ $t('message.common.no_data')}}
      </template>
      </v-data-table>
    </v-card-text>
    <!-- Status close confirm -->
    <v-dialog v-model="cancloseDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
         {{ $t('message.common.confirmation') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <h4>{{ $t('message.tickets.noUserAssigned') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="changedStatusHandler(true)" :loading="cancloseLoading">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="error" @click="closeConfirmDialog">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Comments dialog-->
    <v-dialog v-model="commentsDialog" width="500px">
      <v-card flat class="pa-0">
        <v-card-title>
          {{ $t('message.common.comments') }}
          <v-spacer></v-spacer>
          <v-btn x-small fab @click="commentsDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-progress-linear class="mt-1" color="primary" indeterminate v-if="loadingComments"></v-progress-linear>
          <comments-section class="pt-2" :isView="true" :ticketNumber="0" :assignedto="0" :listOfComments="listOfComments"></comments-section>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="error" @click="commentsDialog = false">{{ $t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  props: ['mailbox', 'selectedTabId'],
  data () {
    return {
      value: '',
      filter: {
        assignedto: 0,
        priority: 0,
        status: [],
        type: 0,
        mailbox: this.mailbox ? this.mailbox : 0,
        category: 0
      },
      menu: {
        assignedto: 0,
        assignedtogroup: 0,
        priority: 0,
        status: [],
        type: 0,
        mailbox: 0,
        category: 0
      },
      fab: false,
      selectedTab: this.selectedTabId ? this.selectedTabId : 'tab-0',
      listOfTickets: [],
      search: '',
      searchUser: '',
      setUserFilter: false,
      closeUserFilter: false,
      searchPriority: '',
      closePriorityFilter: false,
      setPriority: false,
      searchStatus: '',
      setStatus: false,
      closeStatusFilter: false,
      searchType: '',
      searchCategory: '',
      closeCategoryFilter: false,
      setType: false,
      setCategory: false,
      closeTypeFilter: false,
      selected: [],
      loading: false,
      total: 0,
      editTicketItems: [],
      MODULE_URL: 'tickets',
      rendered: 0,
      backupTicketList: [],
      listOfUserAndGroups: [],
      paginationList: {
        itemsPerPageOptions: [10, 25, 50, 100]
      },
      pagination: !this.$formatter.isEmptyObject(this.$store.state.TICKETS_INDEX) ? this.$store.state.TICKETS_INDEX : { sortBy: ['lastmodifiedon'], itemsPerPage: 25, sortDesc: [true], search: '' },
      initKey: 0,
      cancloseDialog: false,
      cancloseLoading: false,
      statusItem: {},
      listOfAirwayBillNumber: [],
      key: 1,
      listOfComments: [],
      commentsDialog: false,
      loadingComments: false,
      canWatchSearchField: true
    }
  },
  components: {
    'comments-section': () => import('./Comments.vue')
  },
  mounted () {
    this.$store.dispatch('getStatus').then(response => {
      if (this.initKey === 0) {
        setTimeout(() => {
          this.loadTicketForTab()
          this.initKey++
        })
      }
    })
    this.$store.dispatch('getPriority')
    this.$store.dispatch('getCustomersList')
    this.$store.dispatch('getUsers')
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getTicketCategory')

    this.$root.$on('mailboxChanged', (data) => {
      this.filter.mailbox = data
    })
    this.$root.$on('closeEdit', (data) => {
      this.listOfTickets.forEach(element => {
        if (element.id === data.ticketid) {
          this.listOfTickets.showStatus = false
        }
      })
      this.getListHandler()
    })
    this.$root.$on('loadTickets', () => {
      this.getListHandler()
    })
    this.$root.$on('tabChanged', (data) => {
      this.search = ''
      this.canWatchSearchField = false
      this.selectedTab = data
      this.loadTicketForTab()
    })
  },
  computed: {
    ...mapState(['listOfTicketPriorities', 'listOfTicketStatus', 'listOfUsers', 'listOfGroups', 'listOfTicketCategories', 'listOfCustomers', 'userDetails']),
    headers () {
      let headers = [
        { text: this.$t('message.tickets.number'), value: 'number', width: '6%' },
        { text: this.$t('message.tickets.status'), value: 'status', width: '8%' },
        { text: this.$t('message.tickets.com'), value: 'totalcommentscount', splvalue: 'Comments', width: '4%' },
        { text: this.$t('message.tickets.from'), value: 'mailfrom', width: '10%' },
        { text: this.$t('message.order.customer'), value: 'customername', width: '7%' },
        { text: this.$t('message.tickets.subject'), value: 'subject', width: '14%' },
        { text: this.$t('message.tickets.assignedTo'), value: 'assignedtoname', width: '10%' },
        { text: this.$t('message.tickets.priority'), value: 'priorityname', width: '9%' },
        { text: this.$t('message.settings.category'), value: 'categoryname', width: '9%' },
        { text: this.$t('message.tickets.lastModified'), value: 'lastmodifiedon', width: '10%' },
        { text: this.$t('message.tickets.lastReceivedorsent'), value: 'lastrepliedon', width: '9%' },
        { text: this.$t('message.common.modifiedBy'), value: 'modifiedbyname', width: '8%' },
        { text: this.$t('message.tickets.mailbox'), value: 'mailboxname', width: '10%' }
      ]
      return headers
    },
    listOfPrioritiesForFilter () {
      let list = this.$formatter.cloneVariable(this.listOfTicketPriorities)
      list.splice(0, 0, { id: 0, name: this.$t('message.tickets.all') })
      return list
    },
    listOfTypesForFilter () {
      let list = this.$formatter.cloneVariable(this.getListOfTicketType)
      list.splice(0, 0, { id: 0, name: this.$t('message.tickets.all') })
      return list
    },
    listOfStatusForFilter () {
      let list = this.$formatter.cloneVariable(this.listOfTicketStatus)
      if (this.filter.status && this.filter.status.length > 0) {
        this.filter.status.forEach(element => {
          list.forEach(status => {
            if (status.id == element) {
              status.selected = true
            }
          })
        })
      }
      return list
    },
    listOfUsersForFilter () {
      let list = this.$formatter.cloneVariable(this.listOfUsers)
      let users = this.$formatter.cloneVariable(list)
      users = [ ...users, ...this.listOfGroups ]
      this.listOfUserAndGroups = users
      list.splice(0, 0, { alternateid: 0, fullname: this.$t('message.tickets.all') })
      list.splice(1, 0, { alternateid: -1, fullname: this.$t('message.tickets.notAssigned') })
      return list
    },
    listOfTypes () {
      return [{
        id: 0,
        name: this.$t('message.tickets.all')
      }, {
        id: 1,
        name: this.$t('message.layout.tickets')
      }, {
        id: 2,
        name: this.$t('message.tickets.tasks')
      }]
    },
    listOfCategoryForFilter () {
      let list = this.$formatter.cloneVariable(this.listOfTicketCategories)
      list.splice(0, 0, { id: 0, name: this.$t('message.tickets.all') })
      return list
    },
    listOfUserMenu () {
      let userMenu = [ ...this.listOfUsersForFilter, ...this.listOfGroups]
      return userMenu.filter(item => {
        if (!this.searchUser) return userMenu
        return (item.fullname.toLowerCase().includes(this.searchUser.toLowerCase()))
      })
    },
    listOfPriorities () {
       return this.listOfPrioritiesForFilter.filter(item => {
        if (!this.searchPriority) return this.listOfPrioritiesForFilter
        return (item.name.toLowerCase().includes(this.searchPriority.toLowerCase()))
      })
    },
    listOfStatus () {
      return this.listOfStatusForFilter.filter(item => {
        if (!this.searchStatus) return this.listOfStatusForFilter
        return (item.name.toLowerCase().includes(this.searchStatus.toLowerCase()))
      })
    },
    listOfCategory () {
       return this.listOfCategoryForFilter.filter(item => {
        if (!this.searchType) return this.listOfCategoryForFilter
        return (item.name.toLowerCase().includes(this.searchType.toLowerCase()))
      })
    }
  },
  watch: {
    pagination: {
      handler (val) {
        const model = { type: 'TICKETS_INDEX', data: val }
        this.$store.commit('rememberOrder', model)
        if (this.rendered !== 0 || !window.localStorage.getItem('tickettab')) {
          this.getListHandler()
        }
      },
      deep: true
    },
    filter: {
      handler (newValue, oldValue) {
        if(this.initKey !== 0) {
          if (newValue || oldValue) {
           this.rememberFilterWithSearch(newValue)
          }
        }
      },
      deep: true
    },
    selected (val) {
      if (val.length === this.listOfTickets.length) {
        this.listOfTickets.forEach(element => {
          element.isSelected = true
        })
      } else if (val.length === 0) {
        this.listOfTickets.forEach(element => {
          element.isSelected = false
        })
      }
    },
    search (val) {
      if (this.canWatchSearchField && !val) this.rememberFilterWithSearch()
    }
  },
  methods: {
    rememberFilterWithSearch (newValue = null) {
      let type = ''
      type = this.findTabName()
      newValue = newValue || this.$formatter.cloneVariable(this.filter)
      newValue.search = this.search
      const data = { type, data: { filter: newValue } }
      let storageName = `${process.env.VUE_APP_NAME}_ticketTabFilters`
      let storedFilters = window.localStorage.getItem(storageName) ? JSON.parse(window.localStorage.getItem(storageName)) : {}
      storedFilters[data.type] = data.data
      window.localStorage.setItem(storageName, JSON.stringify(storedFilters))
      this.getListHandler()
    },
    getListHandler () {
      this.$root.$emit('enableorDisableTab', true)
      this.loading = true
      this.selected = []
      let filter = this.$formatter.cloneVariable(this.filter)
      filter.rowsperpage = this.pagination.itemsPerPage
      filter.descending = this.pagination.sortDesc[0]
      filter.sortby = this.pagination.sortBy[0] === 'assignedtoname' ? 'assignedto' : this.pagination.sortBy[0]
      filter.page = this.pagination.page
      filter.totalItems = 0
      filter.search = this.search
      if ([0, 'tab-0', 'tab-3', 'tab-4'].includes(this.selectedTab)) {
        if (filter.assignedto !== 0 && filter.assignedto !== -1 ) {
          let value = filter.assignedto.split('_')
          if (value[0] === 'user') {
            filter.assignedto = value[1]
            filter.assignedtogroup = 0
          }
          else {
            filter.assignedtogroup = value[1]
            filter.assignedto = 0
          }
        }
      }
      if ((this.selectedTab === 0 || this.selectedTab == 'tab-0') || (this.selectedTab === 1 || this.selectedTab == 'tab-1')) {
        filter.status = []
        filter.status = this.listOfStatus.filter(x => x.isopen).map(x => x.id)
      }
      if (filter.assignedto === -1) filter.assignedtogroup = -1
      this.$_executeApi('post', 'tickets/paginate_filter', filter).then(response => {
        const ticketList = response.data.items
        this.total = response.data.total
        ticketList.forEach(element => {
          element.assignedto = element.assignedto ? `user_${element.assignedto}` :  null
          element.assignedto_group =  element.assignedto_group ? `group_${element.assignedto_group}` : null
          element.showEdit = false
          element.showStatus = false
          element.showAssignedTo = false
          element.showCategory = false
          element.showPriority = false
          element.showCustomer = false
          let mailfrom = element.mailfrom ? JSON.parse(element.mailfrom) : []
          element.mailfrom = mailfrom
        })
        this.backupTicketList = this.$formatter.cloneVariable(ticketList)
        this.listOfTickets = ticketList
      }).finally(() => {
        this.loading = false
        this.rendered = this.rendered + 1
        this.$root.$emit('enableorDisableTab', false)
        window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_ticketStatusFilter`)
      })
    },
    parseData (array) {
      let item = JSON.parse(array)
      let finalArray = []
      item.forEach(element => {
        finalArray.push(this.toLowerCaseKeys(element))
      })
      return finalArray
    },
    toLowerCaseKeys(obj) {
      return Object.keys(obj).reduce(function(accum, key) {
        accum[key.toLowerCase()] = obj[key]
        return accum
      }, {})
    },
    loadTicketForTab () {
      let openStatus = this.listOfTicketStatus.filter(x => x.isopen).map(x => x.id)
      openStatus = openStatus || []
      let closedStatus = this.listOfTicketStatus.filter(x => x.canclose).map(x => x.id)
      closedStatus = closedStatus || []
      let tabName = this.findTabName()
      let storageName = `${process.env.VUE_APP_NAME}_ticketTabFilters`
      let storedFilter = window.localStorage.getItem(storageName) ? JSON.parse(window.localStorage.getItem(storageName)) : {}
      const needFilterValueChange = Boolean(storedFilter && !this.$formatter.isEmptyObject(storedFilter) && storedFilter[tabName])
      const model = needFilterValueChange && storedFilter[tabName] ? storedFilter[tabName] : ''
      this.search = (model && model.filter && model.filter.search) ? model.filter.search : ''
      // If the Filter values are saved in store it replaces the filter value using stored filter values
      if (needFilterValueChange) {
        this.filter = this.$formatter.cloneVariable(model.filter)
        this.menu = this.$formatter.cloneVariable(model.filter)
        this.menu.menuassignedto = this.listOfUserMenu.findIndex(x => model.filter.assignedto && (String(model.filter.assignedto) === String(x.alternateid) || String(model.filter.assignedto).includes(x.id)))
        this.menu.menupriority = this.listOfPriorities.findIndex(x => model.filter.priority  && x.id === model.filter.priority)
        this.menu.menucategory = this.listOfCategory.findIndex(x => model.filter.category  && x.id === model.filter.category)
        model.filter.status = model.filter.status && Array.isArray(model.filter.status) ? model.filter.status : []
        if (tabName === this.ALL_TICKETS)
        {
          if (model.filter.status.length) {
            model.filter.status.forEach(element => {
              this.listOfStatus.forEach(status => { if (status.id == element) status.selected = true })
            })
          }
        } else if ([this.MY_ACTIVE, this.OPEN_TICKETS].includes(tabName)) {
          model.filter.status = openStatus
        } else if (tabName === this.CLOSED) {
          model.filter.status = closedStatus
        }
      } else {
        var status = []
        if (this.$route.query.redirectfrom) {
          status = window.localStorage.getItem(`${process.env.VUE_APP_NAME}_ticketStatusFilter`) ? [window.localStorage.getItem(`${process.env.VUE_APP_NAME}_ticketStatusFilter`)] : []
        }
        switch (tabName) {
          case this.MY_ACTIVE: this.filter = { ...this.filter, assignedto: 0, status: openStatus, priority: 0, category: 0, mailbox: this.mailbox, type: 0 }
            break
          case this.OPEN_TICKETS: this.filter = { ...this.filter, assignedto: this.userDetails.id, status: openStatus, priority: 0, category: 0, mailbox: this.mailbox, type: 0 }
            break
          case this.UNASSIGNED_TICKETS: this.filter = { ...this.filter, assignedto: -1, assignedtogroup: -1, status: [], priority: 0, category: 0, mailbox: this.mailbox, type: 0 }
            break
          case this.CLOSED: this.filter = { ...this.filter, assignedto: 0, status: closedStatus, priority: 0, category: 0, mailbox: this.mailbox, type: 0 }
            break
          case this.ALL_TICKETS:
            this.filter = { ...this.filter, assignedto: 0, status: (status && status.length > 0) ? status: [], priority: 0, category: 0, mailbox: this.mailbox, type: 0 }
            break
        }
      }
    },
    updateTickets (id, index, type) {
      let item = this.$formatter.cloneVariable(this.listOfTickets[index])
      let statusItem = this.listOfTicketStatus.find(x => x.id === item.status)
      let model = {}
      let hideElement = ''
      if (type === 'status' && statusItem && statusItem.canclose && !item.assignedto && !item.assignedto_group) {
        this.statusItem = item
        this.cancloseDialog = true
      } else {
        switch (type) {
          case 'status': model = { status: item.status }
            hideElement = 'showStatus'
            break
          case 'assignedto':
            if (item.assignedto) {
              let assignedTo = item.assignedto.split('_')
              if(assignedTo[0] === 'user') {
                model = { assignedto: parseInt(assignedTo[1]), assignedto_group: null }
              } else model = { assignedto_group: parseInt(assignedTo[1]), assignedto: null }
              if (item.status === parseInt(process.env.VUE_APP_TICKET_STAUS_NEW)) model = { ...model, status: parseInt(process.env.VUE_APP_TICKET_STAUS_INPROGRESS) }
              hideElement = 'showAssignedTo'
            }
            break
          case 'priority': model = { priority: item.priority }
            hideElement = 'showPriority'
            break
          case 'category': model = { category_id: item.category_id }
            hideElement = 'showCategory'
            break
          case 'customer': model = { customerid: item.customerid }
            hideElement = 'showCustomer'
            break
          }
        this.listOfTickets[index][hideElement] = false
        this.listOfTickets[index].modifiedbyname = this.$store.state.userDetails.name
        this.listOfTickets[index].modified_at = moment().format('DD.MM.YYYY HH:mm')
        this.updateTicketsAction(id, model, type, index)
      }
    },
    updateTicketsAction (id, model, type, index) {
      this.cancloseLoading = true
      this.$_executeApi('post', `tickets/update_from_inline/${id}`, model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
        this.sendNotification(index, type)
      }).finally(() => {
        this.cancloseDialog = false
        this.cancloseLoading = false
        this.getListHandler()
      })
    },
    changedStatusHandler () {
      let index = this.listOfTickets.findIndex(x => x.id === this.statusItem.id)
      const model = {
        status: this.statusItem.status,
        assignedto: this.$store.state.userDetails.id
      }
      this.updateTicketsAction(this.statusItem.id, model, 'status', index)
      this.listOfTickets.find(x => {
        if (x.id === this.statusItem.id) {
          x.showStatus = false
        }
      })
    },
    closeConfirmDialog () {
      this.cancloseDialog = false
      this.listOfTickets.find(x => {
        if (x.id === this.statusItem.ticketid) {
          x.showStatus = false
        }
      })
      this.statusItem = {}
    },
    showEditHandler (index) {
      this.listOfTickets[index].showEdit = true
      let item = this.$formatter.cloneVariable(this.listOfTickets[index])
      this.editTicketItems.push(item)
    },
    hideEditHandler (index) {
      this.listOfTickets[index].showEdit = false
    },
    sendNotification (index, type) {
      const item = this.$formatter.cloneVariable(this.listOfTickets[index])
      let matchingItem = this.backupTicketList.find(x => x.id === item.id)
      let msg = ''
      if (item.assignedto) {
        let assignedTo =  this.$formatter.cloneVariable(item.assignedto.split('_'))
        switch (type) {
          case 'status':
              let oldStatus = this.listOfTicketStatus.find(x => x.id === matchingItem.status)
              let newStatus = this.listOfTicketStatus.find(x => x.id === item.status)
              item.statusname = newStatus.name
              item.statuscolor = newStatus.color
              this.$set(this.listOfTickets, index, item)
              if (!oldStatus) msg = `${this.$t('message.tickets.statusSet')} ${newStatus.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
              else  msg = `${this.$t('message.tickets.statusChanged')} ${oldStatus.name} ${this.$t('message.tickets.to')} ${newStatus.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            break
          case 'assignedto':
            let assignedto = parseInt(assignedTo[1])
            if (assignedTo && assignedTo[0] === 'group') {
              let assignedToList =  this.listOfUserAndGroups.find(x => x.alternateid === `${item.assignedto}`)
              if (assignedTo) {
                this.listOfTickets[index].assignedto_group_name = assignedToList.name
                this.listOfTickets[index].assignedtoname = null
                this.sendAssignedNotification(matchingItem.number, assignedToList.name, assignedto, item.id)
              }
            }
            else {
              let assignedToList =  this.listOfUserAndGroups.find(x => x.alternateid === `${item.assignedto}`)
              if (assignedTo) {
                this.listOfTickets[index].assignedtoname = assignedToList.name
                this.listOfTickets[index].assignedto_group_name = null
              }
              let  msg = `${this.$t('message.tickets.assignedtoMessage')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
              this.$eventBus.$emit('SendNotification', [assignedto], msg, item.id)
            }
            break
          case 'priority':
            if (item.priority !==  matchingItem.priority) {
              let oldPriority = this.listOfTicketPriorities.find(x => x.id === matchingItem.priority)
              let newPriority = this.listOfTicketPriorities.find(x => x.id === item.priority)
              if (!oldPriority) msg =`${this.$t('message.tickets.prioritySet')} ${newPriority.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
              else msg = `${this.$t('message.tickets.priorityChanged')} ${oldPriority.name} ${this.$t('message.tickets.to')} ${newPriority.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
                item.priorityname = newPriority.name
                item.prioritycolor = newPriority.color
                this.$set(this.listOfTickets, index, item)
            }
            break
          case 'category':
            if (item.category_id !==  matchingItem.category_id) {
              let oldCategory = this.listOfTicketCategories.find(x => x.id === matchingItem.category_id)
              let newCategory = this.listOfTicketCategories.find(x => x.id === item.category_id)
              item.categoryname = newCategory.name
              this.$set(this.listOfTickets, index, item)
              if (!oldCategory) msg = `${this.$t('message.tickets.categorySet')} ${newCategory.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
              else msg = `${this.$t('message.tickets.categoryChanged')} ${oldCategory.name} ${this.$t('message.tickets.to')} ${newCategory.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
            }
            break
            case 'customer':
              if (item.customerid !==  matchingItem.customerid) {
                let oldCustomer = this.listOfCustomers.find(x => x.id === matchingItem.customerid)
                let newCustomer = this.listOfCustomers.find(x => x.id === item.customerid)
                item.customername = newCustomer.name
                this.$set(this.listOfTickets, index, item)
                if (!oldCustomer) msg = `${this.$t('message.tickets.customerSet')} ${newCustomer.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.invoice.by')} ${this.$store.state.userDetails.name}`
                else msg = `${this.$t('message.tickets.customerChanged')} ${oldCustomer.name} ${this.$t('message.tickets.to')} ${newCustomer.name} ${this.$t('message.tickets.for')} ${matchingItem.number} ${this.$t('message.invoice.by')} ${this.$store.state.userDetails.name}`
              }
              break
          }
        }
        if (item.assignedto || item.assignedto_group) {
          let value = item.assignedto ? item.assignedto : item.assignedto_group
          let assignedTo = this.$formatter.cloneVariable(value.split('_'))
          if (item.assignedto && assignedTo[0] !== 'group') {
            if (this.$store.state.userDetails.id != item.assignedto[1] && type !== 'assignedto') {
              this.$eventBus.$emit('SendNotification', [parseInt(assignedTo[1])], msg, item.id)
            }
          } else {
            if (this.$store.state.userDetails.id !== item.assignedto && type !== 'assignedto' && item.assignedto) {
              // let usersarray = []
              // this.$_executeApi('get', `usergroups/get_by_group/${assignedTo[1]}`).then(result => {
              //   usersarray = result.data.map(x => x.user_id)
              // }).finally(() => {
              //   this.getsignalRConnection.invoke('SendNotification', usersarray, msg, item.id)
              // })
            }
          }
        }
    },
    sendAssignedNotification (number, groupName, grouId, ticketid) {
      // let msg = `${groupName} is assigned for ${number} by ${this.$store.state.userDetails.name}`
      // let usersarray = []
      // this.$_executeApi('get', `usergroups/get_by_group/${grouId}`).then(result => {
      //   usersarray = result.data.map(x => x.user_id)
      // }).finally(() => {
      //   this.getsignalRConnection.invoke('SendNotification', usersarray, msg, ticketid)
      // })
    },
    menuActions (value) {
      if (value) {
        switch (value) {
          case 'merge':
            this.mergeDialogHandler()
            break
          case 'changeStatus':
            this.actionsHandler('statusDialog')
            break
          case 'changePriority':
            this.actionsHandler('priorityDialog')
            break
          case 'assignTo':
            this.actionsHandler('assignedDialog')
            break
          case 'delete':
            this.actionsHandler('deleteDialog')
        }
      }
    },
    clearFilter (type, id) {
      switch (type) {
        case 'assignedto':
          this.setUserFilter = false
          this.filter.assignedto = 0
          setTimeout(() => this.closeUserFilter = false)
          break
        case 'priority':
          this.setPriority = false
          this.filter.priority = 0
          setTimeout(() => this.closePriorityFilter = false)
          break
        case 'status':
          this.setStatus = false
          this.filter.status = []
          this.listOfStatus.map(element => element.selected = false)
          setTimeout(() => this.closeStatusFilter = false)
          break
        case 'category':
          this.filter.category = 0
          setTimeout(() => this.closeCategoryFilter = false)
          break
        case 'type':
          this.filter.type = 0
          setTimeout(() => this.closeTypeFilter = false)
          break
      }
    },
    setFilter (type, id, set) {
      switch (type) {
        case 'assignedto':
          this.setUserFilter = true
          this.closeUserFilter = false
          break
        case 'priority':
          this.setPriority = true
          this.closePriorityFilter = false
          break
        case 'status':
          this.setStatus = true
          /* set.selected = !set.selected
          if (set.selected) this.filter.status.push(id)
          else {
            var index =  this.filter.status.indexOf(id)
            this.filter.status.splice(index, 1)
          } */
          this.closeStatusFilter = false
          break
        case 'category':
          this.setCategory = true
          this.closeCategoryFilter = false
          break
        case 'type':
          this.setType = true
          this.closeTypeFilter = false
          return
      }
    },
    addToSelected (event, item) {
      if (event) {
        this.selected.push(item)
      } else {
        const result = this.selected.filter(x => x.id !== item.id)
        if (result) {
          this.selected = result
        }
      }
    },
    getSelectedName (type, filter, list) {
      let result = {}
      if (type === 'assignedto') {
        list = [ ...this.listOfUsersForFilter, ...this.listOfGroups]
        result = list.find(x => x.alternateid === this.filter[type])
        if (result) return result.fullname
        else return ''
      } else if (type === 'status') {
        let result = this.listOfStatusForFilter.find(x => x.id === this.filter.status[0])
        if (result && this.filter.status) {
          if (this.filter.status.length > 1) return ` ${result.name} (+${this.filter.status.length - 1} others)`
          else return `${result.name}(${this.filter.status.length})`
        } else return ''
      } else {
        result = this[list].find(x => x.id === this.filter[type])
        if (result) return result.name
        else return ''
      }
    },
    getTicketComments (ticketId) {
      this.commentsDialog = true
      this.listOfComments = []
      this.loadingComments = true
      let query = {
        filter: `ticket_id eq ${ticketId || 0}`,
        expand: [{
          select: ['firstname', 'lastname'],
          model: 'User',
          on_field: 'id',
          on_parent_field: 'updated_by',
        }]
      }
      this.$_executeApi('post', `/ticketcomments/query`, query)
        .then(response => {
          let comments = response.data
          comments.forEach(element => {
            if (element.updated_by === -100) {
              element.user_firstname = "Super"
              element.user_lastname = "Admin"
            }
            if (!element.user_firstname) element.user_firstname = 'Unknown'
            element.showEdit = false
          })
          this.listOfComments = comments
        })
        .finally(() => {
          this.loadingComments = false
        })
    },
    findTabName () {
      switch (this.selectedTab) {
        case 'tab-0':
        case 0: return this.MY_ACTIVE
        case 'tab-1': return this.OPEN_TICKETS
        case 'tab-2': return this.UNASSIGNED_TICKETS
        case 'tab-3': return this.CLOSED
        case 'tab-4': return this.ALL_TICKETS
      }
    },
    ticketIsUnread ({ readusers : allReadUsers }) {
      var currentUser = this.userDetails.id
      if (allReadUsers) {
        var readUsers = JSON.parse(allReadUsers)
        return !readUsers.includes(currentUser)
      } else return true
    }
  },
  beforeDestroy () {
    this.$root.$off('tabChanged')
    // this.$root.$off('loadTickets') // Not sure if missed bdrive-but it is not there so I commented out-need to check with Ms.Komathi
    this.$root.$off('mailboxChanged')
    this.$root.$off('closeEdit')
  }
}
</script>
<style>
.checkboxPadding .v-input--selection-controls {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.checkboxPadding .v-text-field--full-width input{
  margin-top: 0 !important;
}
.checkboxPadding .v-text-field--full-width > .v-input__control > .v-input__slot {
  min-height: auto !important;
}
.checkboxPadding .v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 3px !important;
 }
.checkboxPadding .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 !important;
  font-size: 13px;
}
.checkboxPadding .v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: none !important;
}
.checkboxPadding tbody > tr > td, .checkboxPadding table > tbody > tr > th,  .checkboxPadding table > thead > tr > td, .checkboxPadding table > thead > tr > th,  .checkboxPadding  table > tfoot > tr > td,  .checkboxPadding table > tfoot > tr > th {
    padding: 0 5px !important;
    font-size: 0.83rem !important;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.overflow-td {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.underline {
  text-decoration: underline;
}
.select-font {
  font-size: small;
}
</style>
